import React, {Component} from 'react';
import iconsSvg from '../../assets/img/svgLib/iconsSvg';
import PropTypes from 'prop-types';
import './InformationCard.scss';
import Kochkurov from '../../assets/img/kochkurov.png';
import Korolev from '../../assets/img/korolev.png';
import Koryakin from '../../assets/img/koryakin.png';
import Oneshenko from '../../assets/img/oneshko.png';
import Shestakov from '../../assets/img/shestakov.png';
import Volodin from '../../assets/img/volodin.png';
import Akros from '../../assets/img/akros.png';
import Sibserv from '../../assets/img/sibserv.png';
import Tpm from '../../assets/img/tpm.png';
import Gazprom from '../../assets/img/gaz.png';
import RN from '../../assets/img/rn.png';
import LUC from '../../assets/img/luk.png';

class InformationCard extends Component {
  static propTypes = {
    supply: PropTypes.object,
    roleUser: PropTypes.string,
    viewType: PropTypes.string,
    additionalInfo: PropTypes.array,
  }

  constructor(props) {
    super(props)

    this.state = {
      viewType: this.props.viewType, //this.props.viewType,  short or full
    }
  }

  get shortView() {
    const {supply, roleUser} = this.props;
    const userInfo = supply[roleUser];
    const {avatar, name, sureName, middleName, position, phone, email, site, address, logo} = userInfo;
    const ava = avatar === 'kochkurov' ? (<img src={Kochkurov} alt={''}/>) :
      avatar === 'korolev' ? (<img src={Korolev} alt={''}/>) : avatar === 'koryakin' ?
        (<img src={Koryakin} alt={''}/>) : avatar === 'oneshko' ? (<img src={Oneshenko} alt={''}/>) :
          avatar === 'shestakov' ? (<img src={Shestakov} alt={''}/>) : (<img src={Volodin} alt={''}/>);
    const ico = logo === 'akros' ? (<img src={Akros} alt={''}/>) :
      logo === 'sibserv' ? (<img src={Sibserv} alt={''}/>) : logo === 'tpm' ?
        (<img src={Tpm} alt={''}/>) : logo === 'gaz' ? (<img src={Gazprom} alt={''}/>) :
          logo === 'rn' ? (<img src={RN} alt={''}/>) : (<img src={LUC} alt={''}/>);

    return (
      <div style={{height: '400px'}}>
      <div className={'headerBlockInfo'}>
        <div className={'leftBlockInfo'}>
          <div className={'avatar'}>
            {ava}
          </div>
          <div className={'logo'}>
            {ico}
          </div>
        </div>
        <div className={'rightBlockInfo'}>
          <div className={'top'}>
            <div className={'light'}>
              Контактное лицо:
            </div>
            <div className={'dark'}>
              {`${sureName} ${name} ${middleName}`}
            </div>
            <div className={'normal'}>
              {position}
            </div>
          </div>
          <div className={'bottom'}>
            <div className={'light'}>
              Тел:
            </div>
            <div className={'normal'}>
              {phone}
            </div>
            <div className={'light'}>
              e-mail:
            </div>
            <div className={'normal'}>
              {email}
            </div>
            <div className={'light'}>
              Сайт:
            </div>
            <div className={'normal'}>
              {site}
            </div>
          </div>
        </div>
      </div>
        <div className={'footerBlockInfo'}>
          <div className={'light'}>
            Местонахождение:
          </div>
          <div className={'normal'}>
            {address}
          </div>
          <div className={'buttonCall'}>{iconsSvg.mail}</div>
        </div>
      </div>
    )
  }

  get fullView() {
    const {supply, roleUser, additionalInfo} = this.props;
    const userInfo = supply[roleUser];
    if (additionalInfo) {
      const accTmp =  additionalInfo.map(item => {
        return (roleUser === 'debtor' && item.id === supply.idDebtor) ? item :
          (roleUser === 'vendor' && item.id === supply.idVendor) ? item : null

      }).filter(Boolean);
      const {career, inn, kpp, ogrn, okpo, capital, age, companyPrice, billing, profit} = accTmp[0];

    return (
      <div className={'fullView'}>
        <div className={'leftBlock'}>{this.shortView}</div>
        <div className={'rightBlock'}>
          <div className={'title'}>
            Основной вид деятельности:
          </div>
          <div className={'text'}>
            {career}
          </div>
          <div className={'title'}>
            Уставной капитал:
          </div>
          <div className={'text'}>
            {capital}
          </div>
          <div className={'text'}>
            {`${age} лет на рынке`}
          </div>
          <div className={'title'}>
            Стоимость 2017:
          </div>
          <div className={'text'}>
            {companyPrice}
          </div>
          <div className={'title'}>
            Выручка 2017:
          </div>
          <div className={'text'}>
            {billing}
          </div>
          <div className={'title'}>
            Прибыль 2017:
          </div>
          <div className={'text'}>
            {profit}
          </div>
          <div className={'absolut'}>
            <div className={'title'}>
              Реквизиты:
            </div>
            <div className={'text'}>
              {`ИНН: ${inn}`}
            </div>
            <div className={'text'}>
              {`КПП: ${kpp}`}
            </div>
            <div className={'text'}>
              {`ОГРН: ${ogrn}`}
            </div>
            <div className={'text'}>
              {`ОКПО: ${okpo}`}
            </div>
          </div>
        </div>
      </div>
    ) } else return null
  }

  render() {
    const {shortView, fullView} = this;
    const {viewType} = this.state;
    const {supply} = this.props;
    return supply && viewType === 'short' ?
        (<div className={'infoCardContent'}>
        {shortView}
      </div>) : (<div className={'infoCardFull'}>
          {fullView}
        </div>);
  }
}

export default InformationCard



// WEBPACK FOOTER //
// ./src/shared/InformationCard/InformationCard.js